import templateHtml from './setup-application-fees-bank-account-modal.html';

const component = {};

component.template = templateHtml;

component.bindings = {
    isVisible: '=',
    goToSetupCallback: '&'
};

component.controllerAs = 'vm';

function SetupApplicationFeesBankAccountModalController() {
    const vm = this;    

    vm.closeModal = function closeModal() {
        this.isVisible = false;
    };

    vm.goToBankSetupModal = function goToBankSetupModal() {
        if (vm.goToSetupCallback) {
            vm.goToSetupCallback();
        }
    };
}

SetupApplicationFeesBankAccountModalController.$inject = [    
];
component.controller = SetupApplicationFeesBankAccountModalController;
export const SetupApplicationFeesBankAccountModalComponent = component;
